// NewPatientModal.js - Modal runt det gemensamma Ny patient-formuläret
import React from 'react';
import NewPatientForm from './NewPatientForm';
import '../Sidebar/QuickPatientModal.css';

const NewPatientModal = ({ isOpen, onClose, onCreated, onExisting, existingLabel }) => {
  if (!isOpen) return null;

  return (
    <div className="quick-patient-overlay" onClick={onClose}>
      <div className="quick-patient-modal" onClick={(e) => e.stopPropagation()}>
        <div className="quick-patient-header">
          <h3><i className="fas fa-user-plus"></i> Ny patient</h3>
          <button type="button" className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div className="quick-patient-body">
          <NewPatientForm
            onCreated={onCreated}
            onCancel={onClose}
            onExisting={onExisting}
            existingLabel={existingLabel}
          />
        </div>
      </div>
    </div>
  );
};

export default NewPatientModal;
